<template>
  <v-card flat rounded="lg">
    <v-card-title class="font-weight-bold subtitle-1"
      >Assinatura
      <span
        v-if="assinatura_obrigatoria"
        class="ml-2 body-2"
        ><i>(Obrigatória)</i></span
      ></v-card-title
    >
    <v-card-text class="text--center">
      <btn-assinatura-pedido />
      <v-alert
        type="success"
        class="body-2 mt-3"
        dense
        text
        v-if="novopedido.assinatura != ''"
        >Pedido assinado!</v-alert
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import BtnAssinaturaPedido from "./botoes/BtnAssinaturaPedido.vue";
export default {
  props: {
    assinatura_obrigatoria: {type: Boolean, default: true}
  },
  components: { BtnAssinaturaPedido },
  computed: mapState("pedidos", ["novopedido"]),
  methods: {
    ...mapMutations("pedidos", ["setDialogAssinatura"]),
    ...mapGetters("pedidos", ["getTipoPedidoSelec"]),
  },
};
</script>

<style>
</style>